var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.linkFixed,"target":_vm.isExternal || _vm.matchStorage || _vm.newWindow ? '_blank' : '_self'},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }